import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";
import {buildQuery} from "utils/uri";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {LlmRunScore} from "common/flowmaster/types/llm_run";
import {Uuid} from "common/types";

export type GetLlmRunsBatchScoresAction = {
  type: WorkflowsActionTypes["LLM_RUNS_BATCH_SCORES_FETCH"]["SUCCESS"];
  payload: LlmRunScore[];
  action: (organisationId: OrganisationId, batchIds: Uuid[]) => LlmRunScore[];
};

export default function getLlmRunsBatchScores(requestor) {
  return createReduxPromiseAction(
    ActionTypes.LLM_RUNS_BATCH_SCORES_FETCH,
    (organisationId: OrganisationId, batchIds: Uuid[]): LlmRunScore[] => {
      const query = buildQuery({
        batch_id: batchIds,
      });
      return requestor
        .get(
          `${basePath}/organisation/${organisationId}/llm_run/scores${query}`,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
